/* eslint-disable jsx-a11y/anchor-is-valid */
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './Frontend/Component/Header';
import Footer from './Frontend/Component/Footer';
import Zolls from './Frontend/product_category/zolls';
import Battery from './Frontend/product_category/Battery';
import Cabinet from './Frontend/product_category/Cabinet';
import Cprpad from './Frontend/product_category/Cprpad';
import Electropad from './Frontend/product_detail/Electropad';
import Zollaedpro from './Frontend/product_detail/Zollaedpro';
import Contactus from './Frontend/Page/Contactus';
import Aedtraining from './Frontend/Page/AEDtraining';
import Client from './Frontend/Page/Client';
import Zollaed3 from './Frontend/product_detail/Zollaed3';
import Zollaedplus from './Frontend/product_detail/Zollaedplus';
import Zollaed3bls from './Frontend/product_detail/Zollaed3bls';
import Zollbattery from './Frontend/product_detail/Zollbattery';
import Pediatricpad from './Frontend/product_detail/Pediatricpad';
import Boxaed from './Frontend/product_detail/Boxaed';
import AEDtrainer from './Frontend/product_detail/Aedtrainer';
import { Link } from 'react-router-dom'
import BeliZollLanding from "./Frontend/Page/BeliZollLanding";

function AppLayout() {
    const location = useLocation();

    // halaman TANPA header & footer
    const noLayoutRoutes = ["/beli-zoll-aed-plus"];

    const hideLayout = noLayoutRoutes.includes(location.pathname);

    return (
        <>
            {!hideLayout && <Header />}

            <Routes>
                <Route path="/beli-zoll-aed-plus" exact element={<BeliZollLanding />} />

                {/* route lain */}
                <Route path="/" element={<Home />} />
                <Route path="/zolls" exact element={<Zolls />} />
                <Route path="/zoll-cpr-d-padz" exact element={<Electropad />} />
                <Route path="/zoll-aed-pro" exact element={<Zollaedpro />} />
                <Route path="/contact-us" exact element={<Contactus />} />
                <Route path="/zoll-aed-3" exact element={<Zollaed3 />} />
                <Route path="/zoll-aed-plus" element={<Zollaedplus />} />
                <Route path="/zoll-lithium-battery" exact element={<Zollbattery />} />
                <Route path="/zoll-battery" exact element={<Battery />} />
                <Route path="/zoll-aed-3-bls" exact element={<Zollaed3bls />} />
                <Route path="/zoll-aed-pads" exact element={<Cprpad />} />
                <Route path="/zoll-pedi-padz-ii" exact element={<Pediatricpad />} />
                <Route path="/box-aed" exact element={<Boxaed />} />
                <Route path="/cabinet" exact element={<Cabinet />} />
                <Route path="/get-aed-training" exact element={<Aedtraining />} />
                <Route path="/zoll-aed-plus-trainer-2" exact element={<AEDtrainer />} />
                <Route path="/Client" exact element={<Client />} />
                {/* dst */}
            </Routes>

            {!hideLayout && <Footer />}
        </>
    );
}

function App() {

    return (
        <Router>
            <AppLayout />
        </Router>
    );
}

const Home = () => (
    <main className="page-main">
        <main className="page-main-pal container">
            <div className="alocolumns clearfix"><div>
                {/* banner */}
                <div className="section-element row">
                    <div className="col-sm-12 col-md-12 header-top-right mobile-slide">
                        <div className="home-slider" data-slides-to-show={1} data-slides-to-scroll={1} data-fade="false" data-dots="true" data-arrows="false" data-easing="linear" data-autoplay-speed={6000} data-speed={400} data-autoplay="true">
                            <div className="item">
                                <a>
                                    <img className="img-responsive-normal" src="./image/zollwebstore-banner.jpg" alt="magicslider" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* section 1 */}
                <div className="policy">
                    <div className="container-none">
                        <div className="support-policy">
                            <div className="support-footer-inner row">
                                <div className="col col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                    <div className="row-normal clearfix">
                                        <div className="col-icon">
                                            <div className="support-icon square-round">
                                                <em className="pe-7s-plane icons">
                                                    <span className="hidden">hidden</span>
                                                </em>
                                            </div>
                                        </div>
                                        <div className="col-text">
                                            <div className="support-info">
                                                <div className="info-title">FREE SHIPPING FOR JABODETABEK</div>
                                                <span>Consult With Us For Shipping Info.</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                    <div className="row-normal clearfix">
                                        <a target="_blank" href="/Contactus" rel="noreferrer">
                                            <div className="col-icon">
                                                <div className="support-icon square-round">
                                                    <em className="pe-7s-headphones icons">
                                                        <span className="hidden">hidden</span>
                                                    </em>
                                                </div>
                                            </div>
                                            <div className="col-text">
                                                <div className="support-info">
                                                    <div className="info-title">CUSTOMER SERVICE</div>
                                                    <span>Get Help When You Need It.</span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="col col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                    <div className="row-normal clearfix">
                                        <div className="col-icon">
                                            <div className="support-icon square-round">
                                                <em className="pe-7s-refresh-2 icons">
                                                    <span className="hidden">hidden</span>
                                                </em>
                                            </div>
                                        </div>
                                        <div className="col-text">
                                            <div className="support-info">
                                                <div className="info-title">AED TRAINING</div>
                                                <span>We Provide For Jabodetabek Area.</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* section 2 */}
                <div className="row">
                    <div className="col-lg-12">
                        <div className="cms-category section-category">
                            <div className="slider-wrapper content-products home-best-seller">
                                <h2 className="slider-grid-title accor-title">Bestseller Products</h2>
                                <div className="block-content">
                                    <div className="products-grid">
                                        <ol className="products slider-products-grid responsive product-items slick-slider">
                                            {/* loop item */}
                                            <Link to='/zoll-aed-plus'>
                                                <li className="item product-item">
                                                    <div className="product-item-info">
                                                        <img src="https://zollwebstore.com/media//myDevices/images/AEDPlus_1.jpg" alt="ZOLL AED Plus" />
                                                        <div className="product-item-details">
                                                            <strong className="product-item-name">
                                                                <a title="ZOLL AED Plus" href="#" className="product-item-link"> ZOLL AED Plus </a>
                                                            </strong>
                                                        </div>
                                                    </div>
                                                </li>
                                            </Link>
                                            <Link to='/zoll-aed-pro'>
                                                <li className="item product-item">
                                                    <div className="product-item-info">
                                                        <img src="https://zollwebstore.com/media//myDevices/images/AEDPro_1.jpg" alt="ZOLL AED Pro" />
                                                        <div className="product-item-details">
                                                            <strong className="product-item-name">
                                                                <a title="ZOLL AED Pro" href="#" className="product-item-link"> ZOLL AED Pro </a>
                                                            </strong>
                                                        </div>
                                                    </div>
                                                </li>
                                            </Link>
                                            {/* <Link to='/zoll-aed-3-bls'>
                                                <li className="item product-item">
                                                    <div className="product-item-info">
                                                        <img src="https://zollwebstore.com/media//myDevices/images/AED3_BLS_1.jpg" alt="Zoll AED BLS" />
                                                        <div className="product-item-details">
                                                            <strong className="product-item-name">
                                                                <a title="CPR Stat-Padz® Electrode, 8/Case" href="https://zollwebstore.com/8900-0400" className="product-item-link"> ZOLL AED 3 BLS </a>
                                                            </strong>
                                                        </div>
                                                    </div>
                                                </li>
                                            </Link> */}
                                            <Link to='/zoll-aed-3'>
                                                <li className="item product-item">
                                                    <div className="product-item-info">
                                                        <img src="https://zollwebstore.com/media//myDevices/images/AED3_1.jpg" alt="ECG Plain White Paper, 80 mm, 6/Case" />
                                                        <div className="product-item-details">
                                                            <strong className="product-item-name">
                                                                <a title="ECG Plain White Paper, 80 mm, 6/Case" href="https://zollwebstore.com/catalog/product/view/id/25/s/8000-000901-01/" className="product-item-link"> ZOLL AED 3 </a>
                                                            </strong>
                                                        </div>
                                                    </div>
                                                </li>
                                            </Link>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            </div>
        </main>
    </main>
)
export default App;
